'use strict';

var
    loader = require('./loader'),
    culture = require('./culture'),
    smtp = require('./smtpSettings'),
    scroll = require('./scroll'),
    notify = require('./notification');

$(window).on('load', function () {
    loader.clean();
    scroll.add();
    culture.changeModalInit();
    selectNumericTextBox();
    if (!$('#surveyDetailsForm').length && !$('#quotationDetailsForm').length)
        convertDateTimeInDatePickers();

    setWidthForDropdowns();      
});

window.onUserSelect = function onUserSelect(e) {
    if ($(e.item).attr('data-user-action') === 'logout') {
        window.location.href = '/Account/Logout';
    } else if ($(e.item).attr('data-user-action') === 'change') {
        $('#languageWindow').data('kendoWindow').center().open();
    } else if ($(e.item).attr('data-user-action') === "updateSmtp") {
        getSmtpSettingsModal();
    };
};

window.getSmtpSettingsModal = function getSmtpSettingsModal() {
    $.ajax({
        url: '/Account/UpdateSmtp',
        success: function (data) {
            if (data.error !== undefined) {
                notify.showErrorUpdateOnlyText(data.error, data.errorTitle);
            } else {
                $('#smtpWindowPartial').html(data);
                smtp.smtpSettingsInit();
            }
        },
        error: function (data) {
            notify.showErrorUpdateOnlyText(data.error, data.errorTitle);
        }
    });
}

window.selectNumericTextBox = function selectNumericTextBox() {
    $('input[type=text]').bind('focus', function () {
        var input = $(this);
        clearTimeout(input.data('selectTimeId'));

        var selectTimeId = setTimeout(function () {
            input.select();
        });

        input.data('selectTimeId', selectTimeId);
    }).blur(function (e) {
        clearTimeout($(this).data('selectTimeId'));
    });
};

window.setSpinnerById = function setSpinner(id, status) {
    var element = $('#' + id);
    var parent = $(element.parent());
    var originPosition = parent.css('position');
    var spinnerString = "<div id='spinner-" + id + "' class='k-loading-image' style='position: absolute; width: 100%; height: 100%;'></div>";

    if (status) {
        element.before(spinnerString);
        parent.css('position', 'relative');
        element.css('opacity', '0.3');
    } else {
        $('#spinner-' + id).remove();
        parent.css('position', originPosition);
        element.css('opacity', '1');
    }
};

window.setSpinnerByClass = function setSpinnerByClass(elemClass, status) {
    var elements = $('.' + elemClass);

    elements.each(function (i, item) {
        setSpinnerById($(item)[0].id, status);
    });
};

window.setSpinnerSmallById = function setSpinner(id, status) {
    var element = $('#' + id);
    var parent = $(element.parent());
    var originPosition = parent.css('position');
    var spinnerString = "<div id='spinner-" + id + "' class='k-loading-image' style='position: absolute; width: 100%; height: 100%; background-size:30px'></div>";

    if (status) {
        element.before(spinnerString);
        parent.css('position', 'relative');
        element.css('opacity', '0.1');
    } else {
        $('#spinner-' + id).remove();
        parent.css('position', originPosition);
        element.css('opacity', '1');
    }
};

window.convertDateTimeInDatePickers = function convertDateTimeInDatePickers(container, toISO) {
    if (container === undefined) {
        container = '';
    }
    var dateTime,
        id;

    var dateTimePickers = $(container + ' [data-role=datetimepicker]');

    dateTimePickers.each(function (i, item) {
        id = $(item).attr('id');

        //change height of time lists
        //window.changeTimeListHeight(id);

        var picker = $('#' + id).data('kendoDateTimePicker');
        if (picker !== undefined) {
            dateTime = picker.value();
            if (!toISO) {
                picker.value(convertDateTime(dateTime));
            } else {
                picker.value(dateTime.toISOString());
                picker.trigger('change');
            }
            if ($('#' + id).attr('data-value') !== undefined) {
                $('#' + id).attr('data-value', picker.value());
            }
        }
    });
};

window.convertDateTime = function convertDateTime(dateTime, toUTC) {
    if (dateTime === null) {
        return null;
    }
    var now = new Date();
    var offsetMinutes = -dateTime.getTimezoneOffset();
    var converted;

    if (!toUTC){
        converted = new Date(dateTime.setMinutes(dateTime.getMinutes() + offsetMinutes));
    } else {
        converted = new Date(dateTime.setMinutes(dateTime.getMinutes() - offsetMinutes));
    }

    return converted;
};

window.setWidthForDropdowns = function setWidthForDropdowns() {
    $('[data-role="dropdownlist"]').each(function (i, elem) {
        var minWidth = $(elem).parent().width()
        $(elem).data('kendoDropDownList').list.width('auto');
        $(elem).data('kendoDropDownList').list.css('min-width', minWidth);
    });

    $('[data-role="combobox"]').each(function (i, elem) {
        var minWidth = $(elem).parent().width()
        $(elem).data('kendoComboBox').list.width('auto');
        $(elem).data('kendoComboBox').list.css('min-width', minWidth);
    });

    $('[data-role="autocomplete"]').each(function (i, elem) {
        var minWidth = $(elem).parent().width()
        $(elem).data('kendoAutoComplete').list.width('auto');
        $(elem).data('kendoAutoComplete').list.css('min-width', minWidth);
    });
};

function convertInJsDate(ticks) {
    var epochTicks = 621355968000000000,
            ticksPerMillisecond = 10000;

    var jsTicks = (ticks - epochTicks) / ticksPerMillisecond;
    return new Date(jsTicks);
}

window.getStringDateFromTicks = function getStringDateFromTicks(date, format) {
    if (format === undefined || format === null) {
        format = 'd';
    };

    if (date === '') {
        return '-';
    } else {
        var jsDate = convertInJsDate(date);
        return kendo.toString(jsDate, format);
    }
}
